<div fxLayout="column" fxLayoutAlign="end center" fxLayoutGap.gt-md="20px" fxFlexFill>
  <abl-error-list-item
    [@fadeInAndGrow]="'in'"
    *ngFor="let error of errors$ | async; let index = index"
    [error]="error"
    (closeError)="close(index)"
  ></abl-error-list-item>
</div>
